import {Network} from "../../../network/Network";
import {SedestralRouter} from "../../../sedestral/router/SedestralRouter";
import {LoaderStatic} from "./static/loaders/LoaderStatic";
import {SlidingLoaderStatic} from "./static/loaders/sliding/SlidingLoaderStatic";
import {NotificationsStatic} from "./static/notifications/NotificationsStatic";
import {PageLoaderStatic} from "./static/loaders/page/PageLoaderStatic";
import {ProductType} from "../../../models/product/ProductType";
import {TwoFactorStatic} from "./static/twofactor/TwoFactorStatic";
import {
    ISedestralRouterConfig
} from "../../../sedestral/router/types/ISedestralRouterConfig";
import {isMobile} from "../../../sedestral/framework/utilities/IsMobile";
import {
    SedestralInterface
} from "../../../sedestral/framework/interface/SedestralInterface";
import {
    SedestralStorage
} from "../../../sedestral/framework/memory/SedestralStorage";
import {MobileNavigationStatic} from "./static/navigation/mobile/MobileNavigationStatic";

export class PanelRouter extends SedestralRouter {

    public static OAUTH_PENDING_REQUEST_STORAGE = "oauthPendingRequest";

    async init(config?: ISedestralRouterConfig): Promise<void> {
        super.init(config);
        super.initStarted();

        if (Network.logged && this.static.components.navigation) {
            this.static.components.navigation.init();
        }

        //this.static.components.helpCenter.renderAll();

        if (isMobile())
            SedestralInterface.body.addClass("mobile");
    }

    registerPages() {
        this.pages.registerPage("/b", async () => {
            return new (await this.importPage(() => import("./pages/blog/BlogPage"), ProductType.SEDESTRAL)).BlogPage();
        });
        this.pages.registerPage("/404", async () => {
            return new (await this.importPage(() => import("./pages/global/notfound/NotFoundPage"))).NotFoundPage();
        });
        this.pages.registerPage("/login", async () => {
            return new (await this.importPage(() => import("./pages/login/LoginPage"))).LoginPage();
        });
        this.pages.registerPage("/signup", async () => {
            return new (await this.importPage(() => import("./pages/signup/SignupPage"))).SignupPage();
        });
        this.pages.registerPage("/invitation", async () => {
            return new (await this.importPage(() => import("./pages/invitation/InvitationPage"))).InvitationPage();
        });
        this.pages.registerPage("/password", async () => {
            return new (await this.importPage(() => import("./pages/password/lost/PasswordLostPage"))).PasswordLostPage();
        });
        this.pages.registerPage("/admin", async () => {
            return new (await this.importPage(() => import("./pages/admin/AdminPage"))).AdminPage();
        });
        this.pages.registerPage("/onboarding", async () => {
            return new (await this.importPage(() => import("./pages/onboarding/OnboardingPage"))).OnboardingPage();
        });
        this.pages.registerPage("/newLoader", async () => {
            return new (await this.importPage(() => import("./pages/newloader/NewLoaderPage"))).NewLoaderPage();
        });
        this.pages.registerPage("/helpcenter", async () => {
            return new (await this.importPage(() => import("./pages/helpcenter/HelpCenterPage"))).HelpCenterPage();
        });
        this.pages.registerPage("/share", async () => {
            return new (await this.importPage(() => import("./pages/share/SharePage"))).SharePage();
        });
        this.pages.registerPage("/collaboration", async () => {
            return new (await this.importPage(() => import("./pages/collaboration/CollaborationPage"))).CollaborationPage();
        });
        this.pages.registerPage("/oauth", async () => {
            return new (await this.importPage(() => import("./pages/oauth/OAuthPage"))).OAuthPage();
        });
        this.pages.registerPage("/collaborationAgency", async () => {
            return new (await this.importPage(() => import("./pages/collaborationAgency/CollaborationAgencyPage"))).CollaborationAgencyPage();
        });

        this.pages.path404 = "/b";
        this.pages.pathHome = "/b";
        this.pages.pathLogin = "/login";
    }

    registerStatic() {
        this.static.register("loader", new LoaderStatic());
        this.static.register("pageLoader", new PageLoaderStatic());
        this.static.register("slidingLoader", new SlidingLoaderStatic());
        this.static.register("notifications", new NotificationsStatic());

        if (isMobile())
            this.static.register("navigation", new MobileNavigationStatic());
        this.static.register("twoFactor", new TwoFactorStatic());
    }

    onLogin() {
        const pendingOAuthRequest = SedestralStorage.getItem(PanelRouter.OAUTH_PENDING_REQUEST_STORAGE);
        if (pendingOAuthRequest) {
            SedestralStorage.removeItem(PanelRouter.OAUTH_PENDING_REQUEST_STORAGE);
            this.pages.redirect("/oauth/r/" + pendingOAuthRequest);
        } else {
            this.pages.redirect(this.pages.pathHome);
        }
        if (this.static.components.navigation)
            this.static.components.navigation.init();
    }

    onLogout() {
        SedestralStorage.setItem("lastRoute", location.pathname);
        setTimeout(async () => {
            await this.pages.redirect(this.pages.pathLogin);
            this.static.components.navigation.displayHide();
        }, 1500);
    }
}